import { Button } from "@/components/ui/button";
import { can } from "@/lib/rbac";
import { useT } from "@/lib/i18n";
import { Plus, Settings2, Mail, ShoppingCart } from "lucide-react";

export default function DashboardHeader({ facility, role, purchaseCount, onPlantSettings, onDigest, onPurchase, onNewOrder }) {
  const t = useT();
  return (
    <div className="flex items-center justify-between flex-wrap gap-3">
      <div>
        <h1 className="font-display text-2xl font-bold text-slate-900">{t("header.title")}</h1>
        <div className="flex items-center gap-2 mt-0.5">
          <span className="inline-flex items-center gap-1.5 text-[11px] font-semibold px-2 py-0.5 rounded-full bg-blue-50 text-blue-700 border border-blue-200" data-testid="plant-label">
            <span className="h-1.5 w-1.5 rounded-full bg-blue-500" /> {t("header.plant")}: {facility}
          </span>
          <p className="text-sm text-slate-500" data-testid="facility-subtitle">{t("header.subtitle")}</p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        {role === "admin" && (
          <>
            <Button variant="outline" onClick={onPlantSettings} data-testid="btn-plant-settings"><Settings2 className="h-4 w-4 mr-1" /> {t("btn.plantSettings")}</Button>
            <Button variant="outline" onClick={onDigest} data-testid="btn-email-digest"><Mail className="h-4 w-4 mr-1" /> {t("btn.emailDigest")}</Button>
          </>
        )}
        {can.manageOrders(role) && (
          <>
            <Button variant="outline" onClick={onPurchase} className="relative" data-testid="btn-purchase-suggestions">
              <ShoppingCart className="h-4 w-4 mr-1" /> {t("btn.purchaseList")}
              {purchaseCount > 0 && (
                <span className="ml-1.5 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-blue-600 text-white text-[10px] font-bold" data-testid="purchase-count-badge">{purchaseCount}</span>
              )}
            </Button>
            <Button onClick={onNewOrder} className="bg-blue-600 hover:bg-blue-700" data-testid="btn-add-order"><Plus className="h-4 w-4 mr-1" /> {t("btn.newOrder")}</Button>
          </>
        )}
      </div>
    </div>
  );
}
